import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ssrFor, spaLinkHandler } from '../lib/ssrContent';

// WO-42: "Quick answers" and related links (other printings, the set's most valuable cards, Canadian stores) under a
// card, product or set page. The HTML is built by the api from the page's own data (services/seo.py extras_html) and
// is the same block the server-rendered page carries, so what crawlers read is what people see.
export default function SeoExtras() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [html, setHtml] = useState(() => (ssrFor(pathname) || {}).extras || '');

  useEffect(() => {
    const ssr = ssrFor(pathname);
    if (ssr && ssr.extras) {
      setHtml(ssr.extras);
      return undefined;
    }
    const ctrl = new AbortController();
    const apiUrl = process.env.REACT_APP_API_URL || '';
    setHtml('');
    fetch(`${apiUrl}/api/seo/extras?path=${encodeURIComponent(pathname)}`, { signal: ctrl.signal })
      .then((r) => (r.ok ? r.json() : null))
      .then((d) => { if (d && d.html) setHtml(d.html); })
      .catch(() => {});
    return () => ctrl.abort();
  }, [pathname]);

  if (!html) return null;
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div className="lc-server-content mt-10" onClick={spaLinkHandler(navigate)}
         dangerouslySetInnerHTML={{ __html: html }} />
  );
}
